import React, { useState, useEffect } from 'react';
import logo from '../TBL Logo White.png';
import './WineVarietals.css';

const WineVarietals = ({ classVersion, onNext, onBack }) => {
  const [selectedVarietals, setSelectedVarietals] = useState({
    wine1: '',
    wine2: '',
    wine3: ''
  });

  // Load saved varietals from session storage
  useEffect(() => {
    const savedVarietals = sessionStorage.getItem('wineVarietals');
    console.log('WineVarietals: Loading saved varietals:', savedVarietals);
    if (savedVarietals) {
      try {
        const parsedVarietals = JSON.parse(savedVarietals);
        console.log('WineVarietals: Parsed varietals:', parsedVarietals);
        setSelectedVarietals(parsedVarietals);
      } catch (error) {
        console.error('WineVarietals: Error parsing saved varietals:', error);
      }
    }
  }, []);

  // Save varietals to session storage whenever they change
  useEffect(() => {
    console.log('WineVarietals: Saving varietals:', selectedVarietals);
    sessionStorage.setItem('wineVarietals', JSON.stringify(selectedVarietals));
  }, [selectedVarietals]);

  const varietals = [
    'Cabernet Sauvignon',
    'Chardonnay',
    'Grenache',
    'Grenache Blanc',
    'Grenache Gris',
    'Malbec',
    'Merlot',
    'Mourvèdre',
    'Petit Verdot',
    'Petite Sirah',
    'Sauvignon Blanc',
    'Syrah',
    'Tempranillo',
    'Touriga Nacional',
    'Viognier',
    'Zinfandel'
  ];

  const handleVarietalChange = (wine, varietal) => {
    setSelectedVarietals(prev => ({
      ...prev,
      [wine]: varietal
    }));
  };

  const handleNext = () => {
    // Store varietal data for analytics
    const varietalData = {
      selectedVarietals,
      timestamp: new Date().toISOString(),
      classVersion
    };
    
    sessionStorage.setItem('varietalData', JSON.stringify(varietalData));
    onNext();
  };

  const wines = [
    { id: 'wine1', name: 'Wine 1' },
    { id: 'wine2', name: 'Wine 2' },
    { id: 'wine3', name: 'Wine 3' }
  ];

  const allVarietalsSelected = selectedVarietals.wine1 && selectedVarietals.wine2 && selectedVarietals.wine3;

  return (
    <div className={`wine-varietals ${classVersion}-theme`}>
      <div className="varietals-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Navigation
        </button>
        <img src={logo} className="varietals-logo" alt="TBL Logo" />
        <h1>The Wines You Are Using</h1>
        <p className="varietals-description">
          Now that you've completed your blending journey, identify the varietals in each of your wines
        </p>
      </div>

      <div className="varietals-container">
        <div className="wines-varietals-section">
          <h2>Select the Varietal for Each Wine</h2>
          <p className="selection-instruction">
            Choose the grape varietal that best matches each wine you've been working with
          </p>
          
          <div className="wines-varietals-container">
            {wines.map((wine) => (
              <div key={wine.id} className="wine-varietal-card">
                <h3 className="wine-name">{wine.name}</h3>
                <div className="varietal-selection">
                  <select
                    value={selectedVarietals[wine.id]}
                    onChange={(e) => handleVarietalChange(wine.id, e.target.value)}
                    className="varietal-dropdown"
                  >
                    <option value="">Select a varietal...</option>
                    {varietals.map((varietal) => (
                      <option key={varietal} value={varietal}>
                        {varietal}
                      </option>
                    ))}
                  </select>
                  
                  {selectedVarietals[wine.id] && (
                    <div className="selected-varietal">
                      <span className="selected-label">Selected:</span>
                      <span className="selected-value">{selectedVarietals[wine.id]}</span>
                      <button 
                        className="edit-button"
                        onClick={() => handleVarietalChange(wine.id, '')}
                      >
                        Edit
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="action-buttons">
        <button 
          className="next-button" 
          onClick={handleNext}
          disabled={!allVarietalsSelected}
        >
          Complete Class
        </button>
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default WineVarietals;
